// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pqNW1","container_fixed":"styles_container_fixed__Vx1vi"};